<template>
  <v-container
    fluid
    class="pa-0"
    :class="{ 'px-1': $vuetify.display.mdAndDown }"
    data-locator="logs-page"
  >
    <v-row>
      <v-col>
        <LogsTopBar :mnemo="roomMnemo"/>
      </v-col>
    </v-row>

    <v-row v-if="logsStore.hasActiveFilters">
      <v-col>
        <DataTableFiltersSummary
          :active-filters="logsStore.logsFilters"
          class="mt-4"
          @clear-filter="clearFilter"
          @clear-all-filters="clearAllFilters"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <LogsDataTable :mnemo="roomMnemo"/>
      </v-col>
    </v-row>

    <LogsFiltersPane v-if="logsStore.logsFiltersPaneIsOpen"/>

  </v-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

import DataTableFiltersSummary from '@/common/filters/DataTableFiltersSummary.vue'
import { type FilterType } from '@/models/filter.model'
import LogsDataTable from '@/project/logs/LogsDataTable.vue'
import LogsFiltersPane from '@/project/logs/LogsFiltersPane.vue'
import LogsTopBar from '@/project/logs/LogsTopBar.vue'
import { useLogsStore } from '@/stores/logsStore'
export default defineComponent({
  name: 'Logs',
  components: {
    DataTableFiltersSummary,
    LogsDataTable,
    LogsFiltersPane,
    LogsTopBar,
  },
  setup() {
    const logsStore = useLogsStore()
    return { logsStore }
  },
  head () {
    return {
      title: this.$t('project.views.Logs.title'),
    }
  },
  computed: {
    ...mapGetters('room', ['roomMnemo']),
  },
  beforeUnmount () {
    this.clearAllFilters()
  },
  methods: {
    clearFilter (filter: FilterType) {
      // @ts-ignore
      this.logsStore.removeLogFilter(filter)
    },
    clearAllFilters () {
      this.logsStore.logsFilters = []
    },
  },
})
</script>
